import * as Event from '../tools/Event';
import { MQ } from '../tools/MQ';
import { scrollTo } from '../tools/utils';


export const init = () => {
	const SELECTOR = '[data-slide]';

	const onClick = (event) => {
		const element = event.target.closest(SELECTOR);
		const isMobile = MQ('tabletMax');

		if (!element) {
			return;
		}

		event.preventDefault();

		const target = document.querySelector(element.getAttribute('data-slide'));

		if (target) {
			scrollTo(target, isMobile)
				.then(() => element.blur());
		}
	};


	Event.on(document, 'click', onClick, SELECTOR);
};
